import React from 'react';
import {render} from 'react-dom';
import { Router, browserHistory } from 'react-router';
import routes from './routes';

require('./favicon.ico');
require('./styles/insurance-quote.scss');
require('./fonts/ptsans/ptsans.scss');
require('./fonts/bliss2/bliss2.scss');

//let Config = require('Config');
//let TraceKit = require('./tracekit');

window.jQuery = require('jquery');
window.$ = window.jQuery;
jQuery.support.cors = true;

// test for session storage and cookie support
try {
    window.sessionStorage;
    if (navigator.cookieEnabled == '0' || navigator.cookieEnabled === false || typeof navigator.cookieEnabled === "undefined") {
        window.location.replace("/static/enable-cookies.html");
    }
} catch(e) {
    window.location.replace("/static/enable-sessionStorage.html");
}


/**
 * given a key and an array, set that value into the local storage
 * for the answers, overwriting any value which was set for that key
 * @param string key the key of the answer
 * @param mixed value the value of the answer
 */
window.setLocalStorageAnswer = function(key, value) {
    let answers = JSON.parse(window.localStorage.getItem('answers'));

    // if we have it, update the value
    let match = false;
    window.$.each(answers, function() {
        if (this.question === key) {
            this.answer = value;
            match = true;
        }
    });

    // if we didnt already have it, add it
    if (! match) {
        answers.push({
            "question" : key,
            "answer" : value,
        });
    }

    window.localStorage.setItem('answers', JSON.stringify(answers));
};

/**
 * remove an answer object from the main globals answers array
 * @param  {string} key the fieldname of the question to remove from the answers array
 * @return {void}
 */
window.removeLocalStorageAnswer = function(key) {
    let answers = JSON.parse(window.localStorage.getItem('answers'));
    let index = null;
    window.$.each(answers, function(i, e) {
        if (e.question == key) {
            index = i;
        }
    });
    if (index != null) {
        answers.splice(index, 1);
    }
    window.localStorage.setItem('answers', JSON.stringify(answers));
};

/**
 * set of functions to generate a non-perfect, but effective GUID
 * for the purposes of having unique keys in items
 * @return {[type]} [description]
 */
window.s4 = function () {
    return Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1);
};

window.guid = function () {
    return window.s4() + window.s4() + '-' + window.s4() + '-' + window.s4() + '-' +
    window.s4() + '-' + window.s4() + window.s4() + window.s4();
};

window.isEmpty = function(value) {
    if (value == undefined || value == null || value.length == 0) {
        return true;
    }
    if (Object.keys(value).length === 0 && value.constructor === Object) {
        return true;
    }
    return false;
};

/**
 * given a value, return true if the value is undefined OR null
 * or its typeof is "undefined" or "null"
 * @type {bool}
 */
window.uorn = function(value) {
    if (value === undefined || value === null) {
        return true;
    }
    return false;
};

/**
 * returns true if value is undefined or null or typeof "undefined" or typeof "null"
 * or a blank string ("") or a single space (" ")
 * @type {[type]}
 */
window.uornorb = function(value) {
    if (window.uorn(value)) {
        return true;
    } else if (value === '' || value === ' '){
        return true;
    }
    return false;
};

// when we unload the window (i.e closing the tab or browser) delete our data
window.onbeforeunload = function () {
    // "0" means they've closed the browser
    // @TODO removed until decision made about cache clearing
    // on phones, refresh, tab, etc.
    // if (event.currentTarget.performance.navigation.type == 0) {
    if (!window.location.href.includes('/success') && !window.location.href.includes('/payment') && !window.location.href.includes('/inception')) {
        localStorage.removeItem("answers");
       // localStorage.removeItem('flood_risk');
        localStorage.removeItem("jpk");
        localStorage.removeItem("questions_cache");
        localStorage.removeItem("spk");
        localStorage.removeItem("step1");
        localStorage.removeItem("previous_claims");
        localStorage.removeItem("quote");
        localStorage.removeItem("policy");
        localStorage.removeItem("current_step");
        localStorage.removeItem("last_name");
        localStorage.removeItem("temp_email");
        localStorage.removeItem("first_name");
        localStorage.removeItem("last_name");
        localStorage.removeItem("email_address");
        localStorage.removeItem("phone_number");
        localStorage.removeItem("lettertype");
        localStorage.removeItem("MarketingPermission");
    }
    // }
};

render(
    <Router history={browserHistory} routes={routes} />, document.getElementById('insurance-landlord-app')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/